// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as TicketStatus from "../../../../to-be-migrated/domain/types/order/tickets/TicketStatus.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var status = TicketStatus.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
  if (status.TAG === /* Ok */0) {
    var case_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "case_number"), null));
    if (case_number.TAG === /* Ok */0) {
      var crn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crn"), null));
      if (crn.TAG === /* Ok */0) {
        var geo_region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
        if (geo_region.TAG === /* Ok */0) {
          var issues = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issues"), null));
          if (issues.TAG === /* Ok */0) {
            var raised_at = Timestamp$Catalyst.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_date"), null));
            if (raised_at.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        status: status._0,
                        case_number: case_number._0,
                        crn: crn._0,
                        geo_region: geo_region._0,
                        issues: issues._0,
                        raised_at: raised_at._0
                      }
                    };
            }
            var e = raised_at._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".created_date" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = issues._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".issues" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = geo_region._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".city" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = crn._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".crn" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = case_number._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".case_number" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".status" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

export {
  t_decode ,
  
}
/* Timestamp-Catalyst Not a pure module */
